import { Link } from 'react-router-dom'
import { DropletLogo, Wordmark } from '../ui/BrandLogo'
import { useMobileChrome } from './MobileChrome'

export default function TopBar({ action = null, title = null, signedIn = false, meta = null, showCollectionAction = true }) {
  const { collapsed, reveal } = useMobileChrome()
  // A page may set one action or several; they render left to right in the order given.
  const actions = (Array.isArray(action) ? action : [action]).filter(Boolean)

  return (
    <header
      data-collapsed={collapsed ? 'true' : 'false'}
      onFocusCapture={reveal}
      className={`app-topbar fixed left-0 right-0 top-0 z-40 flex items-center justify-between border-b border-white/5 bg-charcoal-900/95 px-4 backdrop-blur transition-transform duration-200 ease-out motion-reduce:transition-none ${collapsed ? 'app-topbar--collapsed' : ''}`}
    >
      <div className="flex min-w-0 items-center gap-2">
        {title ? <h1 className="truncate font-display text-lg tracking-wide text-gold" title={title}>{title}</h1> : <>
          <DropletLogo className="h-7 w-7 shrink-0" />
          <Wordmark className="text-lg" />
        </>}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        {meta ? (
          <p className="whitespace-nowrap text-right text-xs text-cream/45">{meta}</p>
        ) : showCollectionAction ? (
          <Link to={signedIn ? "/collection?add=1" : "/login"} aria-label={signedIn ? "Add to collection" : "Sign in"} className="flex min-h-11 items-center rounded-lg px-3 text-sm font-semibold text-gold hover:bg-white/5">{signedIn ? '+ Add bottles' : 'Sign in'}</Link>
        ) : null}
        {actions.map((item, index) => item.text ? (
          <button
            key={item.text}
            type="button"
            onClick={item.onClick}
            data-header-text-action
            className="flex min-h-11 items-center rounded-lg px-3 text-sm font-semibold text-gold hover:bg-white/5"
          >
            {item.text}
          </button>
        ) : (
          <button
            key={item.label || index}
            type="button"
            aria-label={item.label}
            aria-pressed={item.pressed}
            title={item.label}
            onClick={item.onClick}
            data-header-icon-action={item.id}
            className={`relative flex h-11 w-11 items-center justify-center rounded-full transition-colors hover:bg-white/5 hover:text-gold active:bg-white/10 ${item.pressed ? 'text-gold' : 'text-cream/70'}`}
          >
            {item.icon}
            {item.badge > 0 && (
              <span aria-hidden="true" className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-gold px-1 font-data text-[10px] font-bold text-charcoal-900">
                {item.badge}
              </span>
            )}
          </button>
        ))}

      </div>
    </header>
  )
}
